module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vendor/my-settings-v/tax-forms/tax-forms.component.scss
// module id = ./src/app/pages/vendor/my-settings-v/tax-forms/tax-forms.component.scss
// module chunks = main